import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addTopRatedMovies } from "../utils/movieSlice";
import axios from "axios";

const useTopRatedMovies = () => {
  const dispatch = useDispatch();

  const topRatedMovies = useSelector((store) => store.movies.topRatedMovies);

  const url = "https://api.themoviedb.org/3/movie/top_rated?page=1";

  async function getTopRatedMovies() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;

      if (responseOK) {
        const data = await response.data;
        dispatch(addTopRatedMovies(data.results));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    !topRatedMovies && getTopRatedMovies();
  }, []);
};

export default useTopRatedMovies;
